import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import isCleaner from "../../HOC/IsCleaner";
import CustomerBioShort from "../../components/CustomerBioShort/CustomerBioShort";
import Loader from "../../components/Loader/Loader";
import waiting from '../../constants/images/detailsOrder/waiting.svg';
import techSupportIcon from '../../constants/images/detailsOrder/tech-support.svg';
import { orderActions } from "../../store/slices/orderSlice";
import { MAIN_ROUTES } from "../../routing/main_routes";
import EmptyState from "../EmptyState/EmptyState";
import styles from './ActiveOrdersCleanerPage.module.scss';

const ActiveOrdersCleanerPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {createdOrdersByCleaner, status} = useSelector(state => state.order);

    useEffect(() => {
        const getCreatedOrdersByCurrentUser = async () => {
            try {
                await dispatch(orderActions.getCreatedOrdersByCleaner());
            } catch (error) {
                console.error(error);
            }
        }

        getCreatedOrdersByCurrentUser();
    }, []);

    if (status === 'loading') {
        return <Loader/>;
    }

    return (
        <div className={styles.ordersCleanerPage_wrapper}>
            <div className={styles.ordersCleanerPage}>
                <div className={styles.ordersCleanerPage_orders}>
                    <h2 className={styles.ordersCleanerPage_orders_title}>Активні замовлення</h2>
                    <div className={styles.ordersCleanerPage_orders_content}>
                        {createdOrdersByCleaner?.length === 0 &&
                            <EmptyState
                                icon={waiting}
                                title={'У вас поки немає активних замовлень'}
                                description={'Будь ласка, зачекайте, поки зʼявляться активні замовлення.'}
                            />}

                        {createdOrdersByCleaner?.map((order, index) =>
                            <div className={styles.ordersCleanerPage_orders_item} key={index}>
                                <CustomerBioShort
                                    type={'order'}
                                    order={order.offer.cleaner_request}
                                    offerId={order.offer.id}
                                    orderId={order.offer.order}
                                    application={order.offer.application}
                                />
                                {order.offer.order &&
                                    <div
                                        className={styles.ordersCleanerPage_orders_item_support}
                                        onClick={() => navigate(MAIN_ROUTES.SUPPORT, {
                                            state: {orderId: order.offer.order, autoOpen: true}
                                        })}
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => e.key === 'Enter' && navigate(MAIN_ROUTES.SUPPORT, {
                                            state: {orderId: order.offer.order, autoOpen: true}
                                        })}
                                    >
                                        <img src={techSupportIcon} alt="tech support icon"/>
                                        <p>Звʼязатися з підтримкою</p>
                                    </div>}
                            </div>)}
                    </div>
                </div>
            </div>
        </div>
    )
};

export default isCleaner(ActiveOrdersCleanerPage);
